import { call, takeLatest } from "redux-saga/effects";
import {
  COUPON_LIST,
  COUPON_GET,
  COUPON_CREATE,
  COUPON_UPDATE,
  COUPON_PAUSE,
  COUPON_RESUME,
  COUPON_ARCHIVE,
  COUPON_SERIES_GET,
  COUPON_SERIES_CANCEL,
  COUPON_CODE_LOOKUP,
  COUPON_APPLY,
  COUPON_REVERSE,
  COUPON_USAGE_SYNC,
} from "../types";
import {
  couponListApi,
  couponGetApi,
  couponCreateApi,
  couponUpdateApi,
  couponPauseApi,
  couponResumeApi,
  couponArchiveApi,
  couponSeriesGetApi,
  couponSeriesCancelApi,
  couponCodeLookupApi,
  couponApplyApi,
  couponReverseApi,
  couponUsageSyncApi,
} from "../apis/coupon-api";

function* runOk(action, apiCall) {
  try {
    const res = yield call(apiCall, action.data);
    if (res.status === 200) {
      yield action.onSuccess && action.onSuccess(res.data);
    } else {
      yield action.onError && action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError && action.onError(error?.response?.data || error);
  }
}

function* listWorker(action) { yield* runOk(action, couponListApi); }
function* getWorker(action) { yield* runOk(action, couponGetApi); }
function* createWorker(action) { yield* runOk(action, couponCreateApi); }
function* updateWorker(action) { yield* runOk(action, couponUpdateApi); }
function* pauseWorker(action) { yield* runOk(action, couponPauseApi); }
function* resumeWorker(action) { yield* runOk(action, couponResumeApi); }
function* archiveWorker(action) { yield* runOk(action, couponArchiveApi); }
function* seriesGetWorker(action) { yield* runOk(action, couponSeriesGetApi); }
function* seriesCancelWorker(action) { yield* runOk(action, couponSeriesCancelApi); }
function* codeLookupWorker(action) { yield* runOk(action, couponCodeLookupApi); }
function* applyWorker(action) { yield* runOk(action, couponApplyApi); }
function* reverseWorker(action) { yield* runOk(action, couponReverseApi); }
function* usageSyncWorker(action) { yield* runOk(action, couponUsageSyncApi); }

export function* couponListWatcher() { yield takeLatest(COUPON_LIST, listWorker); }
export function* couponGetWatcher() { yield takeLatest(COUPON_GET, getWorker); }
export function* couponCreateWatcher() { yield takeLatest(COUPON_CREATE, createWorker); }
export function* couponUpdateWatcher() { yield takeLatest(COUPON_UPDATE, updateWorker); }
export function* couponPauseWatcher() { yield takeLatest(COUPON_PAUSE, pauseWorker); }
export function* couponResumeWatcher() { yield takeLatest(COUPON_RESUME, resumeWorker); }
export function* couponArchiveWatcher() { yield takeLatest(COUPON_ARCHIVE, archiveWorker); }
export function* couponSeriesGetWatcher() { yield takeLatest(COUPON_SERIES_GET, seriesGetWorker); }
export function* couponSeriesCancelWatcher() { yield takeLatest(COUPON_SERIES_CANCEL, seriesCancelWorker); }
export function* couponCodeLookupWatcher() { yield takeLatest(COUPON_CODE_LOOKUP, codeLookupWorker); }
export function* couponApplyWatcher() { yield takeLatest(COUPON_APPLY, applyWorker); }
export function* couponReverseWatcher() { yield takeLatest(COUPON_REVERSE, reverseWorker); }
export function* couponUsageSyncWatcher() { yield takeLatest(COUPON_USAGE_SYNC, usageSyncWorker); }
